<template>
  <div class="pre-tx-ack p-2">
    <b-form-row class="mb-2">
      <b-col>
        <div class="alert alert-danger mb-0 py-1 px-2 small-text">
          <b>แพ้:</b> {{ row.patient.allergic || "-" }}
        </div>
      </b-col>
      <b-col>
        <div class="alert alert-warning mb-0 py-1 px-2 small-text">
          <b>โรคประจำตัว:</b> {{ row.patient.congenitalDisease || "-" }}
        </div>
      </b-col>
    </b-form-row>

    <VitalSignsSummary
      v-if="row.vitalSigns.length"
      :readings="row.vitalSigns"
      class="mb-2"
    />
    <div v-else class="mb-2">
      <VitalSignsForm
        v-model="draft"
        :last-measurements="lastMeasurements"
        :id-prefix="`ack-${row.id}`"
      />
      <div class="d-flex justify-content-between align-items-center mt-1">
        <span class="description text-muted"
          >ยังไม่ได้วัด (ไม่บังคับ) · ผู้ช่วยกรอกได้ที่นี่</span
        >
        <b-button
          size="sm"
          variant="outline-info"
          :disabled="isSaving"
          @click="saveVitals"
        >
          บันทึก vital signs
        </b-button>
      </div>
    </div>

    <div class="small-text mb-2">
      <b>ข้อความจากเคาน์เตอร์:</b> {{ row.checkinNote || "-" }}
    </div>
    <div class="d-flex justify-content-end">
      <b-button variant="primary" :disabled="isAcking" @click="acknowledge">
        รับทราบ และเริ่มรักษา
      </b-button>
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/main";
import VitalSignsForm from "@/components/aaci/VitalSignsForm";
import VitalSignsSummary from "@/components/aaci/VitalSignsSummary";
import { emptyReading, toPayload, validateReadings } from "@/utils/vitalSigns";

export default {
  name: "PreTreatmentAckCard",
  components: { VitalSignsForm, VitalSignsSummary },
  props: {
    row: { type: Object, required: true },
  },
  data() {
    return {
      draft: [emptyReading()],
      lastMeasurements: null,
      isSaving: false,
      isAcking: false,
    };
  },
  computed: {
    routeParams() {
      return {
        clinicUrl: this.$route.params.clinicUrl,
        branchUrl: this.$route.params.branchUrl,
      };
    },
  },
  mounted() {
    if (!this.row.vitalSigns.length && this.row.patient.id) {
      this.$store
        .dispatch("moduleAppointment/fetchLatestBodyMeasurements", {
          ...this.routeParams,
          patientId: this.row.patient.id,
        })
        .then(res => {
          this.lastMeasurements = res.data;
        })
        .catch(() => {
          this.lastMeasurements = null;
        });
    }
  },
  methods: {
    toast(message, variant = "warning") {
      eventBus.$emit("alertToast", { message, variant });
    },
    async saveVitals() {
      const readings = toPayload(this.draft);
      if (!readings.length) {
        this.toast("กรุณากรอก vital signs อย่างน้อย 1 ค่า");
        return;
      }
      const error = validateReadings(readings);
      if (error) {
        this.toast(error);
        return;
      }
      this.isSaving = true;
      try {
        await this.$store.dispatch("moduleAppointment/addVitalSigns", {
          ...this.routeParams,
          appointmentId: this.row.id,
          readings,
          source: "DASHBOARD",
        });
        this.draft = [emptyReading()];
      } catch (err) {
        this.toast(
          err.response?.data?.errorMessage || "บันทึก vital signs ไม่สำเร็จ",
          "danger"
        );
      } finally {
        this.isSaving = false;
      }
    },
    async acknowledge() {
      this.isAcking = true;
      try {
        await this.$store.dispatch("moduleAppointment/acknowledgeAppointment", {
          ...this.routeParams,
          id: this.row.id,
        });
        this.$emit("acknowledged", this.row.id);
      } catch (err) {
        if (err.response?.data?.errorMessage === "APPT-NOT-CHECKED-IN") {
          this.toast("คนไข้รายนี้ไม่ได้อยู่ในคิวรอตรวจแล้ว");
          this.$emit("refresh");
        } else {
          this.toast(
            err.response?.data?.errorMessage || "รับทราบไม่สำเร็จ",
            "danger"
          );
        }
      } finally {
        this.isAcking = false;
      }
    },
  },
};
</script>
